import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientContactsService } from '../api/client-contacts.service';
import { CLIENT_CONTACTS_KEYS } from './queryKeys';
import type { UpdateClientContactPayload } from '../types';

export const useUpdateClientContact = (clientId: string, contactId: string) => {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (payload: UpdateClientContactPayload) =>
      clientContactsService.update(clientId, contactId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENT_CONTACTS_KEYS.byClient(orgId, clientId) });
      queryClient.invalidateQueries({
        queryKey: CLIENT_CONTACTS_KEYS.contact(orgId, clientId, contactId),
      });
    },
  });
};

export const useUpdateClientContactMutation = (clientId: string) => {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({
      contactId,
      payload,
    }: {
      contactId: string;
      payload: UpdateClientContactPayload;
    }) => clientContactsService.update(clientId, contactId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENT_CONTACTS_KEYS.byClient(orgId, clientId) });
    },
  });
};
